import React from "react";
import PropTypes from 'prop-types'
import moment from "moment";
import { connect } from 'react-redux'
import * as Yup from 'yup'
import { Row, Col, Modal, Icon, Steps, Tooltip } from 'antd'
import { Formik, FastField } from 'formik'
import typo, { MESSAGE } from '../../../../constants/dictionaries'
import { isEmpty } from "lodash";
import helper from "../../../../helper/helper"
import NumberField from "../../../Common/NumberField"
import DateField from "../../../Common/DateField"
import KetQuaQuanTracModal from "../../FormKetQuaQuanTrac/TNN/index"
// Components
import Input from '../../../Common/Input'
import Button from '../../../Buttons'
import styled from "styled-components";
import Api_tnn from "../../../../api/api.tnn";
import Select from "../../../Common/Select";
import message from "../../../Messages";
import Table from "../../../Table";
import TextArea from "../../../Common/TextArea";
import AddTramModal from './AddTramModal'
import Api_quantrac from "../../../../api/api.quantrac";
import Api from "../../../../api";
const { Step } = Steps;
const ControllerInput = styled.div`
  padding: 0 20px 0 20px;
`;
const schema = Yup.object().shape({
  id_tramquantrac: Yup.string().required(typo.cscore_required),
  dotquantrac: Yup.string().required(typo.cscore_required),
  dotquantrac_ten: Yup.string().required(typo.cscore_required),
});

class ChatLuongNuocThaiModal extends React.Component {
  constructor(props) {
    super(props);
    const { ngaylaymau, ngaynhanmau, ngayphantich } = props.initialValues || {};
    this.QTForm = React.createRef();
    this.TTForm = React.createRef();
    this.state = {
      dataThongSo: [],
      data: [],
      dataTram: [],
      data_qcvn_mdsd: [],
      selectThongso: [],
      currentStep: 0,
      dataDVD: [],
      setModal: false,
      startValue: ngaylaymau ? moment(ngaylaymau) : undefined,
      endValue_BD: ngaynhanmau ? moment(ngaynhanmau) : undefined,
      endValue_KT: ngayphantich ? moment(ngayphantich) : undefined,
    };
  }

  componentDidMount() {
    const { mode, initialValues, dataChatLuong } = this.props
    this.GetQT_ThongSos_By_TPMT()
    this.GetTNN_BCDK_TramQuanTracs_ByGiayPhep()
    this.GetApiQT_DonViDos()
    this.GetQT_DMQCVN_MDSD()
    if (mode === "edit") {
      if (initialValues.list_kqqt) {
        let thongsos = []
        let dataKQQT = initialValues?.list_kqqt && typeof initialValues.list_kqqt === 'string' 
  ? JSON.parse(initialValues.list_kqqt) 
  : initialValues?.list_kqqt 
        dataKQQT.map((item, index) => {
          let thongso = []
          thongso = item.idThongSo
          thongsos.push(thongso)
          item.heso_kq = item.heso_kq ? item.heso_kq : 1
          item.heso_kf = item.heso_kf ? item.heso_kf : 1.0
        })
        this.setState({
          data: dataKQQT,
          selectThongso: thongsos
        })
      }
    } else {
      if (dataChatLuong) {
        let thongsos = []
        let dataKQQT =  dataChatLuong && typeof dataChatLuong === 'string' 
  ? JSON.parse(dataChatLuong) 
  : dataChatLuong
        dataKQQT.map((item, index) => {
          let thongso = []
          thongso = item.idThongSo
          item.mienGiaTri = "="
          item.giaTri = 0
          item.heso_kq = item.heso_kq ? item.heso_kq : 1
          item.heso_kf = item.heso_kf ? item.heso_kf : 1.0
          item.ketqua_danhgia = 2
          thongsos.push(thongso)
        })
        this.setState({
          data: dataKQQT,
          selectThongso: thongsos
        })
      }
    }
  }
  GetApiQT_DonViDos = () => {
    new Api()
      .GetQT_DonViDos({
        token: this.props.user.access_token,
        page: 0,
        size: 0
      })
      .then(res => {
        this.setState({
          dataDVD: res.data
        });
      }).catch(err => {
        message.error(err.message)
      });
  };
  GetQT_DMQCVN_MDSD = () => {
    new Api_quantrac()
      .GetQT_DMQCVN_MDSD({
        token: this.props.user.access_token,
        tpmt_ma: this.props.doiTuongQT
      })
      .then(res => {
        this.setState({
          data_qcvn_mdsd: res
        });
      }).catch(err => {
        message.error(err.message)
      });
  };

  GetTNN_BCDK_TramQuanTracs_ByGiayPhep = () => {
    return new Api_tnn()
      .GetTNN_BCDK_TramQuanTracs_ByGiayPhep({
        token: this.props.user.access_token,
        IdGiayPhep: this.props.idGiayPhep,
      })
      .then((res) => {
        this.setState({
          dataTram: res
        });
      }).catch(err => {
        message.error(err.message)
      })
  };

  GetQT_ThongSos_By_TPMT = () => {
    new Api_quantrac()
      .GetQT_ThongSos_By_TPMT({
        token: this.props.user.access_token,
        tpmt_ma: this.props.doiTuongQT,
      })
      .then(res => {
        this.setState({
          dataThongSo: res.map((item, index) => ({ ...item, thongso: item.tenThongSo + " (" + item.tenDonVi + ")" + " - " + item.kyHieuThongSo })),
        });
      }).catch(err => {
        message.error(err.message)
      });
  };

  handleAddTram = (value) => {
    this.GetTNN_BCDK_TramQuanTracs_ByGiayPhep()
    this.setState({
      setModal: false
    })
  }


  onChange = current => {
    const { mode } = this.props
    {
      mode !== "add" &&
        this.setState({ currentStep: current })
    }
  };
  next = () => {
    const currentStep = this.state.currentStep + 1;
    this.setState({ currentStep });
  }

  prev = () => {
    const currentStep = this.state.currentStep - 1;
    this.setState({ currentStep });
  }
  disabledStartDate = startValue => {
    const { endValue_BD } = this.state;
    if (!startValue || !endValue_BD) {
      return false;
    }
    return startValue.valueOf() > endValue_BD.valueOf();
  };

  disabledEndDate = endValue_BD => {
    const { startValue } = this.state;
    if (!endValue_BD || !startValue) {
      return false;
    }
    return endValue_BD.valueOf() < startValue.valueOf();
  };

  disabledEndDate_KT = endValue_KT => {
    const { endValue_BD } = this.state;
    if (!endValue_KT || !endValue_BD) {
      return false;
    }
    return endValue_KT.valueOf() < endValue_BD.valueOf();
  };
  handleSubmit = () => {
    const { handleOk } = this.props
    const { state } = this.TTForm.current;
    const formQT = this.QTForm.current.handleSubmit()
    if (!isEmpty(state.errors)) {
      message.warning(MESSAGE.CSCORE_ERROR_THONG_TIN)
    } else {
      handleOk({ ...state.values, list_kqqt: JSON.stringify(formQT.data), ketqua_danhgia: formQT.ketqua, thongso_vuotnguongs: formQT.vuotnguong });
    }
  }
  render() {
    const { isOpen, handleCancel, handleOk, initialValues, mode, user, isEdit, doiTuongQT, idGiayPhep, view } = this.props;
    const { startValue, endValue_BD, endValue_KT, dataThongSo, data, selectThongso, currentStep, dataTram, setModal, dataDVD,
      data_qcvn_mdsd
    } = this.state
    return (
      <Modal
        visible={true}
        title={isEdit ? typo.cscore_cap_nhat_kqqt : typo.cscore_them_moi_kqqt}
        footer={false}
        onCancel={handleCancel}
        width="1100px"
        maskClosable={false}
      // centered
      >
        <div>
          <div>
            <Steps current={currentStep} onChange={this.onChange} style={{ width: "85%", textAlign: "center" }}>
              <Step title={typo.cscore_common_info} />
              <Step title={typo.cscore_ket_qua_QT} />
            </Steps>
            <Row className="mt-20" />
            <Row style={{ display: currentStep === 0 ? "block" : "none" }}>
              <Formik
                ref={this.TTForm}
                enableReinitialize
                initialValues={initialValues}
                onSubmit={(value, actions) => {
                  actions.resetForm({});
                }}
                validationSchema={schema}
                render={({ handleChange, handleSubmit, values, errors, touched, setFieldValue, dirty }) => (
                  <form onSubmit={handleSubmit} autoComplete={false}>
                    <Row>
                      <Col span={12}>
                        <ControllerInput>
                          <FastField name="mau_kyhieu" render={({ field }) => (
                            <Input label={typo.cscore_key} mandatory={false}{...field} />)} />

                          <FastField name="mau_ten" render={({ field }) => (
                            <Input label={typo.cscore_sample_name} mandatory={false} {...field} />)} />

                          <FastField name="mau_tinhtrang" render={({ field }) => (
                            <Input label={typo.cscore_tinh_trang} mandatory={false}{...field} />)} />

                          <FastField name="donvithuchien" render={({ field }) => (
                            <Input label={typo.cscore_don_vi_thuc_hien} mandatory={false}{...field} />)} />

                          <Row type="flex">
                            <Col span={view === 'view' ? 24 : 21}>
                              <Select
                                dataSource={dataTram.map((item) => ({ ...item, hienThi: item.tenTram + " - " + item.diaDiem }))}
                                defaultValue={values.id_tramquantrac ? Number(values.id_tramquantrac) : undefined}
                                onChange={(value, name) => {
                                  setFieldValue("id_tramquantrac", value);
                                  setFieldValue("ten_tramquantrac", helper.getFieldValueFromID(value, dataTram, "tenTram"));
                                }}
                                placeholder={typo.cscore_vi_tri_quan_trac}
                                label={typo.cscore_vi_tri_quan_trac}
                                width="100%"
                                name="hienThi"
                                name_value="id"
                                key={values.id_tramquantrac}
                              />
                            </Col>
                            <Col span={view === 'view' ? 0 : 3}>
                              <Row type="flex" align="bottom" style={{ height: "100%", float: "right" }}>
                                <Button type="primary" onClick={() => this.setState({ setModal: true })}>
                                  <Icon style={{ color: '#fff' }} type="plus" />
                                </Button>
                              </Row>
                            </Col>
                          </Row>

                          <FastField name="dotquantrac_ten" render={({ field }) => (
                            <Input label={typo.cscore_dot_quan_trac_ten} {...field} />)} />

                          <NumberField
                            label={typo.cscore_dot_quan_trac_number}
                            placeholder={typo.cscore_dot_quan_trac_number}
                            id="dotquantrac"
                            min={0}
                            onChange={value => setFieldValue("dotquantrac", value)}
                            value={values.dotquantrac}
                          />
                        </ControllerInput>
                      </Col>
                      <Col span={12}>
                        <ControllerInput>
                          <FastField name="nguoilaymaus" render={({ field }) => (
                            <Input label={typo.cscore_nguoi_lay_mau} mandatory={false}{...field} />)} />

                          <FastField name="nguoigiamsats" render={({ field }) => (
                            <Input label={typo.cscore_nguoi_giam_sat} mandatory={false}{...field} />)} />

                          <DateField
                            disabledDate={this.disabledStartDate}
                            placeholder={helper.genSelectPL(typo.cscore_ngay_lay_mau)}
                            label={typo.cscore_ngay_lay_mau}
                            onChange={value => {
                              this.setState({ startValue: value });
                              setFieldValue("ngaylaymau", value && value.format())
                            }}
                            value={startValue}
                            mandatory={false}
                          />

                          <DateField
                            disabledDate={this.disabledEndDate}
                            placeholder={helper.genSelectPL(typo.cscore_ngay_nhan_mau)}
                            label={typo.cscore_ngay_nhan_mau}
                            onChange={value => {
                              this.setState({ endValue_BD: value });
                              this.setState({ endValue_KT: undefined });
                              setFieldValue("ngaynhanmau", value && value.format());
                              setFieldValue("ngayphantich", undefined)
                            }}
                            value={endValue_BD}
                            mandatory={false}
                          />

                          <DateField
                            disabledDate={this.disabledEndDate_KT}
                            placeholder={helper.genSelectPL(typo.cscore_ngay_phan_tich)}
                            label={typo.cscore_ngay_phan_tich}
                            onChange={value => {
                              this.setState({ endValue_KT: value });
                              setFieldValue("ngayphantich", value && value.format())
                            }}
                            value={endValue_KT}
                            mandatory={false}
                          />
                          <NumberField
                            label={typo.cscore_luuLuongNuocThai}
                            placeholder={typo.cscore_luuLuongNuocThai}
                            mandatory={false} id="luuLuong"
                            min={0}
                            onChange={value => setFieldValue("luuLuong", value)}
                            value={values.luuLuong}
                          />

                          <FastField name="nguonNuoc" render={({ field }) => (
                            <Input placeholder={typo.cscore_nguonNuocXaSSD} label={typo.cscore_nguonNuocXaSSD} mandatory={false}{...field} mode={mode} />)} />

                          <FastField name="mau_mota" render={({ field }) => (
                            <TextArea label={typo.cscore_note} mandatory={false}{...field} />)} />

                        </ControllerInput>
                      </Col>
                    </Row>
                  </form>
                )} />
            </Row>

            <div style={{ display: currentStep === 1 ? "block" : "none" }}>
              <KetQuaQuanTracModal
                thanh_phan_moi_truong={doiTuongQT}
                ref={this.QTForm} user={user}
                selectThongso={selectThongso} dataThongSo={dataThongSo}
                data={data} data_qcvn_mdsd={data_qcvn_mdsd}
                dataDVD={dataDVD}
                view={view}
              />
            </div>
          </div>

          <Row className="mt-20" />
          {mode !== "presentation" &&
            <Row>
              <Col span={12}>
                {mode === "add" &&
                  <div>
                    {currentStep !== 0 &&
                      <Button type="outline" onClick={() => this.prev()}><Icon type="left" />{typo.cscore_back}</Button>}
                    {currentStep === 0 &&
                      <Button type="outline" onClick={handleCancel}><Icon type="left" />{typo.cscore_back}</Button>}
                  </div>
                }
              </Col>
              <Col span={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                {mode !== "add" && view !== 'view' &&
                  <Button type="submit" onClick={() => this.handleSubmit()}><Icon type="save" />{typo.cscore_save}</Button>
                }
                {mode === "add" && currentStep === 1 &&
                  <Button type="submit" onClick={() => this.handleSubmit()}><Icon type="save" />{typo.cscore_save}</Button>
                }
                {mode === "add" && currentStep === 0 &&
                  <Button type="outline" onClick={() => this.next()}><Icon type="right" />{typo.cscore_next}</Button>
                }
                {mode !== "add" &&
                  <Button type="cancel" style={{ marginLeft: '10px' }} onClick={handleCancel}><Icon type="arrow-right" />{typo.cscore_exit}</Button>
                }
              </Col>
            </Row>}

          {setModal &&
            <AddTramModal
              handleCancel={() => this.setState({ setModal: false })}
              handleAdd={this.handleAddTram}
              isOpen={setModal}
              idGiayPhep={idGiayPhep}
              doituongQT={doiTuongQT}
            />}
          {/*<DisplayFormikState error={errors} value={values} touched={touched}/>*/}

        </div>
      </Modal>
    )
  }
}
ChatLuongNuocThaiModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  initialValues: PropTypes.object,
  handleOk: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  /*Mode: add, edit, presentation*/
  mode: PropTypes.string,
};

const mapStateToProps = (state) => ({
  user: state.oidc.user
});

export default connect(mapStateToProps)(ChatLuongNuocThaiModal)

const GroupWrapper = styled.div`
  max-width: 80%;
  padding: 5px 10px;
`;

